import React from 'react'
import ReturnBreadCrumbs from 'components/breadCrumb/NewBreadCrumbs'
import time from 'assets/Images/time-event.svg'
import locationImg from 'assets/Images/location-event.svg'
import {
  capitalizeFirstLetter,
  convertMinutesToLocalTime,
  convertToLocal,
  formatAddress,
} from 'helper/utility'
import { ExternalEventResp } from 'types/external/externalEvent'
import ManageButtonExternal from './ManageButtonExternal'

interface ProfileHeaderExternalProps {
  event?: ExternalEventResp
}

const ProfileHeaderExternal: React.FC<ProfileHeaderExternalProps> = ({
  event,
}) => {
  return (
    <div>
      <div className="flex justify-between">
        <ReturnBreadCrumbs
          links={[
            { name: 'Events', link: '/spaces?page=1&limit=10' },
            {
              name: `${event?.name || ''}`,
              link: `/evnets/external-detail/${event?._id}`,
            },
          ]}
        />
        {event?._id && (
          <ManageButtonExternal id={event._id} status={event.status} />
        )}
      </div>

      <div className="w-80p">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '40% 60%',
            gap: '50px',
          }}
        >
          <img
            src={event?.coverPhotos?.[0]?.post}
            alt="external-img"
            style={{ width: '100%', height: '300px', borderRadius: '15px' }}
          />
          <div className="flex justify-end flex-col">
            <h2 className="text-40 my-20px">
              {capitalizeFirstLetter(event?.name || '')}
            </h2>
            <div className="flex mt-20px">
              {/* <div className="flex">
                <div>
                  <img src={time} alt="time" />
                </div>
                <div className="ml-10px">
                  <h4 className="text-12 grey-txt">Time</h4>
                  {event && (
                    <>
                      <h4 className="text-14 w-500">
                        Starts on {convertToLocal(event.startDate, 'MMM D,YYYY')}
                      </h4>
                      <h4 className="text-14 w-500">
                        {convertMinutesToLocalTime(event.timings.startTime)}-
                        {convertMinutesToLocalTime(event.timings.endTime)}
                      </h4>
                    </>
                  )}
                </div>
              </div> */}
              <div className="flex">
                <div>
                  <img src={locationImg} alt="location" />
                </div>
                <div className="ml-10px">
                  <h4 className="text-12 grey-txt">Location</h4>
                  <div>
                    {event?.venueType === 'to-be-determined' ? (
                      <h4 className="text-14 w-500">To Be Determined</h4>
                    ) : event?.venueType === 'virtual' ? (
                      <h4 className="text-14 w-500">Online Event</h4>
                    ) : event?.location ? (
                      formatAddress(event?.location)
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileHeaderExternal
